import { ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core'
import { AvatarService } from './../avatar/avatar.service'
import { AvatarStyle } from './../avatar/avatar-data'

@Component({
  standalone: false,
  selector: 'se-count-avatar',
  host: {'class': 'se-count-avatar'},
  templateUrl: './count-avatar.component.html'
})
export class SeCountAvatarComponent {

  @Input('se-data-size') size: string
  @Input('se-data-border') border: boolean = false
  @Input('se-data-count') count: number = 0

  @HostBinding('class.se-count-avatar') baseClass: boolean = true

  public componentClass: string = 'se-avatar'
  public componentStyle: AvatarStyle
  public countString: string

  constructor(private changeDetectorRef: ChangeDetectorRef,
              private avatarService: AvatarService) {
    // noop
  }

  ngOnChanges(): void {
    this.init()
  }

  public async init(): Promise<void> {
    const data = await this.avatarService.getData(this.size, this.border)
    this.componentClass = data.componentClass
    this.componentStyle = data.componentStyle
    this.countString = `+${this.count.toLocaleString()}`
    this.changeDetectorRef.detectChanges()
  }

}
